<template>
  <validation-observer ref="simpleRules">
    <feature-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus.status"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import FeatureForm from '@/views/Admin/Defines/Feature_groups/FeatureGroupsForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Add',
  components: {
    FeatureForm,
    SaveButton,
    ValidationObserver,
  },

  computed: {
    dataItem() {
      return this.$store.getters['featureGroups/dataItem']
    },
    submitStatus() {
      return this.$store.getters['featureGroups/submitStatus']
    },
    saveData() {
      return this.$store.getters['featureGroups/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/admin/defines/feature-groups')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.$store.commit('featureGroups/RESET_DATA_ITEM')
    this.submitStatus.status = false
    localize('tr')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus.status = true
          this.$store.dispatch('featureGroups/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>

<style scoped>

</style>
